import { useNavigate } from 'react-router-dom';
import { Plus, Lock as LockIcon } from 'lucide-react';
import PlanGate from '../../../../components/gating/PlanGate';

const RoleManagementHeader = ({ isRestricted }) => {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mb-4 sm:mb-6">
      <div>
        <h1 className="text-xl sm:text-2xl font-black text-[#067978] tracking-tight uppercase">ROLE MANAGEMENT</h1>
        <p className="text-xs sm:text-sm text-slate-500 mt-0.5 sm:mt-1">Manage team sub-accounts, roles, and access credentials.</p>
      </div>
      {!isRestricted && (
        <PlanGate
          requiredPlan="enterprise"
          featureName="Role Management"
          tooltipText="Role & Team Management requires the Enterprise Plan."
          showLockIcon={false}
          wrapperClassName="w-full sm:w-auto"
        >
          {({ isLocked }) => (
            <button 
              onClick={() => navigate('/role-management/add')}
              className="flex items-center justify-center gap-2 bg-[#067978] hover:bg-[#056362] text-white px-5 sm:px-6 py-2.5 sm:py-3 rounded-2xl font-bold text-xs sm:text-sm shadow-md shadow-[#067978]/20 transition-all hover:shadow-lg active:scale-95 whitespace-nowrap w-full sm:w-auto cursor-pointer"
            >
              <Plus size={18} className="stroke-[2.5]" />
              <span>Add User</span>
              {isLocked && <LockIcon size={14} className="ml-1 text-white/90 shrink-0" />}
            </button>
          )}
        </PlanGate>
      )}
    </div>
  );
};

export default RoleManagementHeader;
